import { Inject, Injectable } from '@angular/core';
import { ApiClientConfig } from '../api-client-config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateTemplateRequest,
  CreateTemplateResponse,
  Template,
  TemplateWithUser,
} from '@primatoo-ms-organization';
import { map } from 'rxjs/operators';
import { TemplateDocumentType, UpdateTemplateRequest } from '@pt/pt-models';
import { ListTemplateChaptersForDownload } from 'it/primatoo/openapi/api/org/schemas/template/ListTemplateChaptersForDownload';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  private readonly endpointV1: string;
  private readonly endpointV2: string;

  static orderTemplateForId(template: Template[]): Template[] {
    return template.sort((a, b) => {
      if (a.id > b.id) {
        return 1;
      } else if (a.id < b.id) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  constructor(
    @Inject(ApiClientConfig) private config,
    private httpClient: HttpClient
  ) {
    this.endpointV1 = this.config.endPoint + '/api/org/templates/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/templates/';
  }
  //
  // /**
  //  *
  //  * @param name
  //  */
  // public findAllTemplatesByName(templateDocumentType: TemplateDocumentType): Observable<Template[]> {
  //   const url = this.endpointV1 + `name/${templateDocumentType}/`;
  //   return this.httpClient.get<Template[]>(url);
  // }

  /**
   *
   * @param body
   * @param templateDocumentType
   */
  createTemplate(
    body: CreateTemplateRequest,
    templateDocumentType: TemplateDocumentType
  ): Observable<CreateTemplateResponse> {
    const url = this.endpointV1 + `name/${templateDocumentType}/`;
    return this.httpClient.post<CreateTemplateResponse>(url, body);
  }

  /**
   *
   * @param body
   */
  updateTemplate(
    body: UpdateTemplateRequest
  ): Observable<CreateTemplateResponse> {
    const url = this.endpointV1 + `${body.id}/`;
    return this.httpClient.patch<CreateTemplateResponse>(url, body.request);
  }

  /**
   *
   * @param templateDocumentType
   */
  findAllTemplate(
    templateDocumentType: TemplateDocumentType
  ): Observable<Template[]> {
    const url = this.endpointV1 + `name/${templateDocumentType}/`;
    return this.httpClient.get<Template[]>(url).pipe(
      map((r: Template[]) => {
        return TemplateService.orderTemplateForId(r);
      })
    );
  }

  /**
   *
   * @param name
   */
  public findDocTemplateChapters(
    templateDocumentType: TemplateDocumentType
  ): Observable<ListTemplateChaptersForDownload> {
    const url = this.endpointV2 + `name/${templateDocumentType}/chapters/`;
    return this.httpClient.get<ListTemplateChaptersForDownload>(url);
  }

  /**
   *
   * @param templateId
   */
  findTemplateWithUser(templateId: number): Observable<TemplateWithUser> {
    const url = this.endpointV1 + `${templateId}/details`;
    return this.httpClient.get<TemplateWithUser>(url);
  }

  /**
   *
   * @param templateId
   */
  selectTemplate(templateId: number) {
    const url = this.endpointV1 + `${templateId}/select`;
    return this.httpClient.post(url, {});
  }

  /**
   *
   * @param templateId
   */
  deleteTemplate(templateId: number) {
    const url = this.endpointV1 + `${templateId}/delete`;
    return this.httpClient.delete(url);
  }

  /**
   *
   */
  deletenNotUsedTemplate() {
    const url = this.endpointV1 + `unused/`;
    return this.httpClient.delete(url);
  }
}
